import { useState } from "react";
import { Plus } from "lucide-react";
import CustomSelect from "./CustomSelect";

const EnhancedTestSelector = ({ label, tests, onAdd, icon: Icon }) => {
  const [selectedTest, setSelectedTest] = useState(null);

  const testOptions = tests.map((test) => ({
    value: test[0],
    label: test[3],
    data: test,
  }));

  const handleAdd = () => {
    if (selectedTest) {
      onAdd(selectedTest.data);
      setSelectedTest(null);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-3">
      <div className="flex items-center space-x-2 mb-4">
        <Icon className="text-blue-600" size={20} />
        <p className="text-lg font-semibold text-gray-800">{label}</p>
      </div>
      <div className="flex space-x-2">
        <CustomSelect
          options={testOptions}
          value={selectedTest}
          onChange={setSelectedTest}
          placeholder={`Select ${label.toLowerCase()}...`}
          className="flex-1"
        />
        <button
          onClick={handleAdd}
          disabled={!selectedTest}
          className="px-2 py-2 bg-green-600 text-white font-medium rounded-lg shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
        >
          <Plus size={18} />
        </button>
      </div>
    </div>
  );
};

export default EnhancedTestSelector;
